<template>
  <el-dialog
    :title="$t('indexMenu.delete.title')"
    :visible.sync="visible"
    width="30%"
    @close="handleClose"
  >
    <div class="delete-content">
      <p>{{ $t('indexMenu.delete.confirmText') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="handleConfirm"
        :loading="loading"
      >
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteShopMenu } from '@/api/phone/indexMenuApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteIndexMenu',
  data() {
    return {
      visible: false,
      loading: false,
      menuId: '',
      shopId: ''
    }
  },
  methods: {
    open(row) {
      this.shopId = getShopId()
      this.menuId = row.menuId
      this.visible = true
    },
    async handleConfirm() {
      try {
        this.loading = true
        await deleteShopMenu({
          menuId: this.menuId,
          shopId: this.shopId
        })
        this.$message.success(this.$t('indexMenu.delete.success'))
        this.$emit('success')
        this.visible = false
      } catch (error) {
        this.$message.error(this.$t('indexMenu.delete.error'))
      } finally {
        this.loading = false
      }
    },
    handleClose() {
      this.menuId = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-content {
  text-align: center;
  font-size: 16px;
  padding: 20px 0;
}
</style>